import getApi from '../../api'

export const createInsiLogs = (payload: Record<string, string>) =>
  getApi().post<void>('/logs/insi', payload)
